import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstancesController::index
* @see app/Http/Controllers/AdminPanel/WhatsappInstancesController.php:22
* @route '/admin-panel/whatsapp-instances'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin-panel/whatsapp-instances',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstancesController::index
* @see app/Http/Controllers/AdminPanel/WhatsappInstancesController.php:22
* @route '/admin-panel/whatsapp-instances'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstancesController::index
* @see app/Http/Controllers/AdminPanel/WhatsappInstancesController.php:22
* @route '/admin-panel/whatsapp-instances'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstancesController::index
* @see app/Http/Controllers/AdminPanel/WhatsappInstancesController.php:22
* @route '/admin-panel/whatsapp-instances'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstancesController::index
* @see app/Http/Controllers/AdminPanel/WhatsappInstancesController.php:22
* @route '/admin-panel/whatsapp-instances'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstancesController::index
* @see app/Http/Controllers/AdminPanel/WhatsappInstancesController.php:22
* @route '/admin-panel/whatsapp-instances'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstancesController::index
* @see app/Http/Controllers/AdminPanel/WhatsappInstancesController.php:22
* @route '/admin-panel/whatsapp-instances'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstancesController::destroy
* @see app/Http/Controllers/AdminPanel/WhatsappInstancesController.php:47
* @route '/admin-panel/whatsapp-instances/{instance}'
*/
export const destroy = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin-panel/whatsapp-instances/{instance}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstancesController::destroy
* @see app/Http/Controllers/AdminPanel/WhatsappInstancesController.php:47
* @route '/admin-panel/whatsapp-instances/{instance}'
*/
destroy.url = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { instance: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { instance: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            instance: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        instance: typeof args.instance === 'object'
        ? args.instance.id
        : args.instance,
    }

    return destroy.definition.url
            .replace('{instance}', parsedArgs.instance.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstancesController::destroy
* @see app/Http/Controllers/AdminPanel/WhatsappInstancesController.php:47
* @route '/admin-panel/whatsapp-instances/{instance}'
*/
destroy.delete = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstancesController::destroy
* @see app/Http/Controllers/AdminPanel/WhatsappInstancesController.php:47
* @route '/admin-panel/whatsapp-instances/{instance}'
*/
const destroyForm = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstancesController::destroy
* @see app/Http/Controllers/AdminPanel/WhatsappInstancesController.php:47
* @route '/admin-panel/whatsapp-instances/{instance}'
*/
destroyForm.delete = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const whatsappInstances = {
    index: Object.assign(index, index),
    destroy: Object.assign(destroy, destroy),
}

export default whatsappInstances